import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Softwaredevelopment/Hero";
import DevelopServices from "../components/Softwaredevelopment/DevelopServices";
import TransformSection from "../components/Softwaredevelopment/TransformSection";
import Process from "../components/Softwaredevelopment/Process";
import IndustryBussinessjs from "../components/Softwaredevelopment/IndustryBussinessjs";
import Commitment from "../components/Softwaredevelopment/Commitment";
import Customers from "../components/Softwaredevelopment/Customers";
import Success from "../components/Softwaredevelopment/Success";
import PageTitle from "../components/Softwaredevelopment/PageTitle";


import '../assets/Webdevelopment.css';



const Softwaredevelopment = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<TransformSection />
	    	<Process />
	    	<IndustryBussinessjs />
	    	<Commitment />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default Softwaredevelopment;
